module.exports = __webpack_public_path__ + "img/730f5c9.png";